export enum ErrorItemType {
  error = "error",
  warning = "warning"
}

export type ErrorItem = {
  statusCode?: number;
  additionalErrorText?: string;
  errorText: string;
  id?: string;
  type?: ErrorItemType.error | ErrorItemType.warning;
};
